var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterstedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43564"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2342",
    cx: 30.5,
    cy: 30,
    r: 30,
    fill: "#0088FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M45.8333 45V43.2856H37.5V41.6667C37.5 40.3406 36.9732 39.0688 36.0355 38.1311C35.0979 37.1934 33.8261 36.6667 32.5 36.6667H20.8333C19.5073 36.6667 18.2355 37.1934 17.2978 38.1311C16.3601 39.0688 15.8333 40.3406 15.8333 41.6667V43.2856H12.5V45H45.8333ZM26.6667 21.6667C25.5129 21.6667 24.3851 22.0088 23.4258 22.6498C22.4666 23.2907 21.7189 24.2018 21.2774 25.2677C20.8359 26.3336 20.7203 27.5065 20.9454 28.638C21.1705 29.7696 21.7261 30.809 22.5419 31.6248C23.3577 32.4406 24.3971 32.9962 25.5286 33.2212C26.6602 33.4463 27.8331 33.3308 28.899 32.8893C29.9649 32.4478 30.8759 31.7001 31.5169 30.7408C32.1579 29.7815 32.5 28.6537 32.5 27.5C32.5 25.9529 31.8854 24.4692 30.7915 23.3752C29.6975 22.2812 28.2138 21.6667 26.6667 21.6667ZM42.5 15L40.0509 19.9625L34.5745 20.7582L38.5373 24.6209L37.6018 30.0752L42.5 27.5L47.3982 30.0752L46.4628 24.6209L50.4255 20.7582L44.9491 19.9625L42.5 15Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterstedIcon);
export default __webpack_public_path__ + "static/media/interstedIcon.bdfeab1b68c12d1b8165d4d2c8e19f3f.svg";
export { ForwardRef as ReactComponent };